import React, {useState} from 'react';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import numericFunction from "../../../utils/NumericFunction";
import './ShowReport.scss';

const FilterReport = (props) => {

  const [newDate, setNewDate] = useState({
    startDate: "",
    endDate: ""
  });

  const sendNewData = () => {
    props.setDateFilter({
      startDate: numericFunction.p2e(newDate.startDate),
      endDate: numericFunction.p2e(newDate.endDate)
    })
  }

  try {
    return (
      <div className={"my-4 text-center line-date-filter"}>
        <div className="mx-1">
          <div className="form-control" style={{margin: '5px auto'}}>
            <DatePicker
              onChange={(date) => {
                if (date) {
                  setNewDate({...newDate, startDate: date.toLocaleString()});
                } else {
                  setNewDate({...newDate, startDate: ""});
                }
              }}
              calendar={persian}
              className="form-control"
              placeholder="تاریخ شروع"
              locale={persian_fa}
              value={newDate.startDate}
              calendarPosition="bottom-right"
              hideOnScroll
            />
          </div>
        </div>
        <div className="mx-1">
          <div className="form-control" style={{margin: '5px auto'}}>
            <DatePicker
              onChange={(date) => {
                if (date) {
                  setNewDate({...newDate, endDate: date.toLocaleString()});
                } else {
                  setNewDate({...newDate, endDate: ""});
                }
              }}
              calendar={persian}
              className="form-control"
              placeholder="تاریخ پایان"
              locale={persian_fa}
              value={newDate.endDate}
              calendarPosition="bottom-right"
              hideOnScroll
            />
          </div>
        </div>
        <div className="mx-1">
          <button className={"filter-button"} type="button" onClick={sendNewData}> نمایش</button>
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default FilterReport;
